import NextLink from 'next/link';
import React from 'react';
import { AccessControlledComponents } from '~/constants';
import useAppContext from '~/hooks/useAppContext';

type NextLinkProps = React.ComponentProps<typeof NextLink>;

interface LinkProps extends NextLinkProps {
	componentName?: AccessControlledComponents;
}

export const AccessControlledLink = ({ componentName, children, ...props }: LinkProps) => {
	const { hasComponentAccess } = useAppContext();

	const hasAccess = componentName ? hasComponentAccess(componentName) : true;

	if (hasAccess) {
		return <NextLink {...props}>{children}</NextLink>;
	}

	return null;
};
